import { withRouter } from "react-router-dom";
import React, { Component } from "react";
import { Popover, message } from "antd";
import { Button, Card, CardBody } from "reactstrap";
import Axios from "axios";

import Loader from "../../../Global/Loader";
import Table from "../../Components/Table";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import "./style/style.scss";

import { Services } from "../../../../repositories/clients/Services";

class AdminUser extends Component {
  constructor(props) {
    super(props);
    var DateExcel = "";
    var timestamp = Date.now();
    var date = new Date(timestamp);
    var month = String(date.getMonth() + 1).padStart(2, "0");
    DateExcel =
      "User" + date.getFullYear() + "" + month + "" + date.getDate() + ".xlsx";
    this.state = {
      loadingInfo: true,
      data: [],
      userInfo: [],
      popVisible: [],
      catalogs: [],
      selectCatalog: [],
      modalTitle: "",
      modalVisible: false,
      preview: true,
      createFormData: "",
      generalInfo: "",
      showCatalogModal: [],
      prevUserInfo: [],
      activePage: 1,
      DateExcel,
      errorPass: true,
      viewpass: false,
      isEdit: false,
      tableConf: [
        {
          label: "ID",
          key: "UserId",
          // custom: (value) => (
          //   <label className="table-link clickable" onClick={() => this.showGeneralInfo(value)}>{value.UserId}</label>
          // )
        },
        { label: "Nombre", key: "Name" },
        { label: "Apellido", key: "LastName" },
        { label: "Rol", key: "Rol" },
        { label: "Email", key: "Email" },
        { label: "Teléfono", key: "Telephone" },
        { label: "Fecha de Creación", key: "CreateDate" },
        { label: "Organizaciones Asociadas", key: "AssociatedEntities" },
        {
          label: "",
          key: "",
          custom: (value) => (
            <Popover
              onVisibleChange={this.handlePopChange(value)}
              placement="left"
              trigger="hover"
              visible={value.showPop}
              title={<hr className="hr-popover"></hr>}
              content={() => {
                return (
                  <div>
                    <div className="row">
                      <div
                        className="col-12"
                        style={{
                          marginBottom: "1em",
                          textAlign: "center",
                        }}
                      >
                        <p class="seacargo-pop-icon">
                          <em class="fas fa-exclamation-triangle"></em>
                        </p>
                        <p>¿Estás seguro que deseas eliminar el usuario?</p>
                      </div>

                      <div className="col-12" style={{ textAlign: "center" }}>
                        <Button
                          content="OK"
                          // negative={false}

                          style={{
                            color: "white",

                            backgroundColor: "#020E3A",
                          }}
                          color="primary"
                          onClick={() => this.deleteUser(value)}
                        >
                          Si
                        </Button>
                        <Button
                          content="Cancelar"
                          // negative={false}
                          style={{
                            color: "white",
                            marginLeft: "10px",
                            backgroundColor: "#FF0000",
                          }}
                          color="danger"
                          onClick={() => {
                            this.handleCancel(value);
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              }}
            >
              <em
                onClick={""}
                style={{
                  color: "#FF0000",
                  marginLeft: "10%",
                  marginTop: " 4px",
                  fontSize: "20px",
                }}
                className="fa-2x mr-2 fas fa-trash-alt"
              ></em>
            </Popover>
          ),
        },
      ],
    };
  }

  showGeneralInfo = (value) => {
    this.props.history.push(`/altausuario/${value.UserId}`);
  };

  handleCancel = (value) => {
    let { data } = this.state;
    data.forEach((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = false;
      }
    });
    this.setState({
      data,
    });
  };
  handlePopChange = (value) => (visible) => {
    let { data } = this.state;
    data.forEach((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = visible;
      }
    });
    this.setState({
      data,
    });
  };

  componentDidMount = () => {
    this.getUserService();

    this.setState({ loadingInfo: false });
  };

  getUserService = async () => {
    let { data } = this.state;
    await Axios.get(`${Services.ADMIN.path}admin/users`)
      .then((response) => {
        data = response.data.data;
        data.forEach((d) => {
          d.showPop = false;
        });
      })
      .catch((error) => {});
    this.setState({ data, activePage: 1 });
  };

  deleteUser = (value) => {
    let id = value.UserId;
    Axios.delete(`${Services.ADMIN.path}admin/deleteUser/${id}`)
      .then((response) => {
        this.sendMessage("Usuario Eliminado", "success");

        this.getUserService();
      })
      .catch((error) => {
        if (error.response) {
          var mensaje = "";
          if (error.response.data.data) {
            mensaje = error.response.data.data.message;
          } else {
            mensaje = error.response.data.message;
          }
          this.sendMessage(mensaje, "error");
        }
      });
  };

  sendMessage = (text, type) => {
    var messageClass = "";
    if (type === "error") {
      messageClass = "general-custom-ant-message error-custom-ant-message";
    } else if (type === "success") {
      messageClass = "general-custom-ant-message success-custom-ant-message";
    } else if (type === "info") {
      messageClass = "info-custom-ant-message";
    }
    message.open({
      content: text,
      className: messageClass,
    });
  };

  crearUsuario = () => {
    this.props.history.push("/altausuario");
  };

  updateActivePage = (activePage) => {
    this.setState({ activePage });
  };
  render() {
    let {
      loadingInfo,
      tableConf,
      data,
    } = this.state;
    return (
      <>
        {loadingInfo ? (
          <Loader />
        ) : (
          <ContainerWrapper>
            <div className="content-heading">
              <legend
                style={{ marginLeft: "10px" }}
                className="styleTitleModule"
              >
                <em
                  // onClick={this.moreContact()}
                  className="icon-final-37"
                  style={{ color: "#020E3A" }}
                ></em>
                Administración
              </legend>
            </div>
            <Card>
              {/* <CardHeader> */}
              <div class="col-12">
                <h4>Usuarios Registrados</h4>
                <hr class="hr-seacargo-red"></hr>
              </div>
              {/* </CardHeader> */}
              <CardBody>
                {/* <div className="row">
                <div className="col-12" style={{ fontSize: "30px", paddingRight: "30px", paddingBottom: "30px" }}>
                  <button onClick={() => { this.crearUsuario() }} className="float-right">
                    <em className="fas fa-plus-circle">
                    </em></button>
                </div>
              </div> */}
                <div className="row">
                  <div className="col-12">
                    <Table
                      columns={tableConf}
                      data={data}
                      rowClick={true}
                      customClick={this.showGeneralInfo}
                      itemsByPage={10}
                      updateActivePage={this.updateActivePage}
                      activePage={this.state.activePage}
                      customAdd={
                        <button
                          style={{ fontSize: "30px" }}
                          onClick={() => {
                            this.crearUsuario();
                          }}
                          className="float-right"
                        >
                          <em className="fas fa-plus-circle"></em>
                        </button>
                      }
                      options={{
                        large: false,
                        downloads: {
                          pdf: false,
                          xlsx: false,
                        },
                        pagination: true,
                        search: true,
                        searchKeys: ["Name", "LastName", "Email"],
                      }}
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </ContainerWrapper>
        )}
      </>
    );
  }
}

export default withRouter(AdminUser);
